import { IMPLEMENTATION_CONSTANTS } from "./constants";
import PlainTextFrame from "@/components/plainText";

const Implementation = () => {
  return <PlainTextFrame {...IMPLEMENTATION_CONSTANTS} />;
};

export default Implementation;
